import { render } from "./CheckListPage.vue?vue&type=template&id=5c04e3b6&scoped=true"
import script from "./CheckListPage.vue?vue&type=script&lang=js"
export * from "./CheckListPage.vue?vue&type=script&lang=js"

import "./CheckListPage.vue?vue&type=style&index=0&id=5c04e3b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c04e3b6"]])

export default __exports__